export const formatPrice = (price, currency) => {
  const int = parseInt(price);

  if (currency === "SEK" || currency === "NOK") {
    // To get custom format "1.234" for SE/NO websites
    const locale = "it-IT";

    return `${int.toLocaleString(locale)} kr`;
  }

  if (currency === "EUR") {
    // Always use this locale for EUR at the moment
    const locale = "fi-FI";

    return int.toLocaleString(locale, {
      style: "currency",
      currency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });
  }

  console.error("Unexpected error in formatPrice");
  return null;
};
